import script from "./SocialInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialInput.vue?vue&type=script&setup=true&lang=js"

import "./SocialInput.vue?vue&type=style&index=0&id=46902628&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46902628"]])

export default __exports__